/**
 *  @class
 *  @function CartRemove
 */
if (!customElements.get('cart-remove')) {
  class CartRemove extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClickHandler.bind(this));
    }
    onClickHandler(event) {
      // MPC: D R2 — no coordinator (the asset did not load): let the keyed <a href> inside this
      // element remove the line natively instead of swallowing the click.
      if (!window.CstCart) return;
      event.preventDefault();
      // MPC: D R1 — the KEY addresses the line; the index only finds the row node for the spinner.
      const key = this.dataset.key;
      const index = this.dataset.index;
      const cartDrawer = this.closest('cart-drawer');
      if (cartDrawer) {
        cartDrawer.updateQuantity(key, '0', index);
      } else {
        document.dispatchEvent(new CustomEvent('cart:remove', { detail: { key, index } }));
      }
    }
  }
  customElements.define('cart-remove', CartRemove);
}
